import PropTypes from 'prop-types';
// material
import { styled } from '@material-ui/core/styles';

// material
import { Box, Backdrop, Paper, Tooltip, Divider, Typography, Stack, Avatar, Grid, IconButtonm, Popover, TextField, Button, LinearProgress, Card, Accordion, AccordionSummary, AccordionDetails, CardMedia } from '@material-ui/core';
import { MIconButton } from '../@material-extend';
import { Icon } from '@iconify/react';
import closeFill from '@iconify/icons-eva/close-fill';
import { useDispatch, useSelector } from '../../redux/store';
import { onAcceptAllConnect, onAcceptConnect, onRejectConnect } from '../../redux/slices/widget';
//
// ----------------------------------------------------------------------

import { useNavigate } from 'react-router-dom';
export default function StatusConnectingWidget({ open }) {
    const { queue_live } = useSelector(state => state.widget);
    console.log(queue_live)
    const navigate = useNavigate();
    const dispatch = useDispatch(); 
    const onHandleAccept = () => {
        dispatch(onAcceptConnect([queue_live.slice(-1)[0]]))
    }
    const onHandleAcceptAll = () => {
        dispatch(onAcceptAllConnect(queue_live))
        navigate('/channel/livechat/chat')
    }
    const onHandleReject = () => {
        dispatch(onRejectConnect(queue_live))
        navigate('/channel/livechat/chat')
    }
    return (
        <Box
            sx={{
                top: 12,
                bottom: 12,
                right: 0,
                position: 'fixed',
                zIndex: 2002,
                ...(open && { right: 12 })
            }}
        >
            <Box
                sx={{
                    p: 0.5,
                    px: '4px',
                    mt: 0,
                    right: 0,
                    top: '40%',
                    color: 'grey.800',
                    position: 'absolute',
                    bgcolor: 'common.white',
                }}
            >
                <Paper
                    sx={{
                        // height: 1,
                        // width: '0px',
                        width: '100%', height: "100%",
                        overflow: 'hidden',
                        boxShadow: (theme) => theme.customShadows.z24,
                        transition: (theme) => theme.transitions.create('width'),
                        ...(open && { width: 300, height: "12%" }),
                        //backgroundImage: 'url(https://api-multichannel.voip24h.vn/public/images/popup-dialing.svg)',
                        // backgroundSize: 'cover', // or 'contain'
                    }}
                >
                    <Stack direction="row" alignItems="center" justifyContent="start" spacing={1} sx={{ py: 1, pr: 1, pl: 2.5 }}>
                        <Stack direction="row" >
                            <MIconButton onClick={() => onHandleAccept()}>
                                <Icon icon="ph:check-bold" width={20} height={20} />
                            </MIconButton>
                            <MIconButton onClick={() => onHandleAcceptAll()}>
                                <Icon icon="ci:check-all" width={20} height={20} />

                            </MIconButton>


                        </Stack>

                        <Stack>
                            <Typography fontSize={"12px"}>
                                Bạn đang có {queue_live.length} cuộc trò chuyện trực tuyến đang chờ...
                            </Typography>
                            <MIconButton onClick={() => onHandleReject()}>
                                <Icon icon={closeFill} width={20} height={20} />
                            </MIconButton>
                        </Stack>
                    </Stack>
                    <Divider />

                </Paper>

            </Box>
        </Box>

    )
}
